import { jsx as l, Fragment as b } from "react/jsx-runtime";
import { cloneElement as B } from "react";
import E from "classnames";
import { s as e, B as L } from "../../ButtonLinkBase-B9JYK0kL.js";
const W = ({
  cloneElement: o,
  destructive: a,
  size: m = "medium",
  representation: d = "link",
  variant: n = "primary",
  external: t,
  trailingIcon: f,
  leadingIcon: u,
  hideExternalIcon: c,
  isFullwidth: h,
  isFullwidthMobile: y,
  loading: s,
  disabled: g,
  onClick: i,
  suppressHydrationWarning: k
}) => {
  const r = o;
  return B(
    r,
    {
      "data-testid": r.props["data-testid"] ?? "link",
      className: E(
        e[n === "inline" ? "link" : d],
        e[m],
        e[n],
        {
          [e.destructive]: a,
          [e.fullwidth]: h,
          [e["fullwidth-mobile"]]: y,
          [e.disabled]: g || s,
          [e.loading]: s
        },
        r.props.className
      ),
      suppressHydrationWarning: r.props.suppressHydrationWarning,
      target: r.props.target ?? (t ? "_blank" : "_self"),
      ...t ? { rel: r.props.rel ?? "noreferrer noopener" } : {},
      onClick: (p) => {
        s ? p.preventDefault() : i == null || i(p);
      }
    },
    /* @__PURE__ */ l(b, { children: /* @__PURE__ */ l(
      L,
      {
        loading: s,
        trailingIcon: f || (t && !c ? "externalLink" : void 0),
        leadingIcon: u,
        suppressHydrationWarning: k,
        children: r.props.children
      }
    ) })
  );
};
export {
  W as default
};
